import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom'
import { AgentuserUpdate, AgentfetchUser } from '../../features/dashboard/AgentManagmentSlice';
import Header from './Header';
import Broadcast from './Broadcast';
import Button from '../form/Button';
import Loading from '../../Loading';
import { ToastContainer, toast } from 'react-toastify';

function EditAgent () {
    const {id} = useParams()
    const userName = useRef();
    const mobile = useRef();
    const password = useRef()
    const city = useRef()
    
    const [FlagStatus, setFlag] = useState(false)
    const Agentflag = useRef(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let {
        Agentperson,
        Agentsuccess,
        Agentstatus,
        Agentloading,
        Agentmessage,
        AgenterrorName,
        AgenterrorMobile,
        AgenterrorCity,
        AgenterrorFlag,
        AgenterrorPassword
    } = useSelector(state => state.AgentManagment)

    const userUdateHandler = (event) => {
        event.preventDefault();
        const data = {
            'id': id,
            'name': userName.current.value,
            'mobile': mobile.current.value,
            'password': password.current.value,
            'city': city.current.value,
            'flag': FlagStatus == true ? '1' : null,
        }
        dispatch(AgentuserUpdate(data));
        
    }
    const flagHandler = () => {

    }
    const goToUserIndex = () => {
        navigate('/dashboard/agents', { replace: true })
    }



    useEffect(() => {
        AgenterrorName = ''
        AgenterrorMobile = ''
        AgenterrorFlag = ''
        AgenterrorPassword = ''
        dispatch(AgentfetchUser(id))
        return () => {
            Agentperson = []
            AgenterrorName = ''
            AgenterrorMobile = ''
            AgenterrorFlag = ''
            AgenterrorPassword = ''
        }
    },[])
    useEffect(() => {
        if(Agentsuccess === true){
            setFlag(Agentperson.status == '1' ? true : false);
        }
    },[Agentperson])

    useEffect(() => {
        if(Agentsuccess === true && Agentstatus === true && Agentloading === false && Agentmessage != "") {
            toast.success(Agentmessage,{
                position: "top-center",
                autoClose: 1200,
              })
              Agentmessage = ''
        }

        if(Agentsuccess === false && Agentstatus === false && Agentloading === false && Agentmessage != "") {
            toast.error(Agentmessage,{
                position: "top-center",
                autoClose: 1200,
              })
              Agentmessage = ''
        }
    },[Agentloading,Agentsuccess, Agentmessage])

    return (
        <>
        { Agentloading ? (<Loading />) : null}
        <Broadcast title={'ویرایش نماینده'} />
        <form className="text-end  ">
        <div className='row rahpardaznet-cart my-5 print-position'>
                <div className=" row col-12">
                    <div className="col-12 col-md-6">
                        <div className="m-3 rahpardaznet-form-controll">
                            <label forhtml="staticName" className="fw-bold text-end form-label px-1">
                            نام نماینده
                            </label>
                                <input
                                    tabIndex="1" 
                                    type="text"
                                    defaultValue={Agentperson.name} 
                                    ref={userName}
                                    className="form-control shadow-none" 
                                    id="staticName" 
                                    autoFocus
                                />
                                {
                                    (AgenterrorName) ? (
                                    <span className="help-block fw-bold d-inline-block mt-2">
                                        <small className='text-danger validate-error'>{ AgenterrorName }</small>
                                    </span>
                                ):''}
                            </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="m-3 rahpardaznet-form-controll">
                            <label forhtml="staticName" className="fw-bold text-end form-label px-1">
                             شهر
                            </label>
                                <input
                                    tabIndex="1" 
                                    type="text"
                                    defaultValue={Agentperson.city} 
                                    ref={city}
                                    className="form-control shadow-none" 
                                    id="staticName" 
                                    autoFocus
                                />
                                {
                                    (AgenterrorCity) ? (
                                    <span className="help-block fw-bold d-inline-block mt-2">
                                        <small className='text-danger validate-error'>{ AgenterrorCity }</small>
                                    </span>
                                ):''}
                            </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="m-3 rahpardaznet-form-controll">
                            <label forhtml="staticMobile" className="fw-bold text-end form-label px-1">
                            موبایل
                            </label>
                            <input
                                tabIndex="2" 
                                type="text"
                                defaultValue={Agentperson.mobile}
                                ref={mobile}
                                className="form-control shadow-none text-left ltr" 
                                id="staticEmail" 
                            />
                            {
                                (AgenterrorMobile) ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger validate-error'>{ AgenterrorMobile }</small>
                                </span>
                            ):''}
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="m-3 rahpardaznet-form-controll">
                            <label forhtml="staticPassword" className="fw-bold text-end form-label px-1">
                            گذرواژه
                            </label>
                            <input
                                autoComplete="new-password"
                                tabIndex="3" 
                                defaultValue=''
                                type="password"
                                ref={password}
                                className="form-control shadow-none" 
                                id="staticPassword" 
                                placeholder="در صورت تغیر گذرواژه جدید را وارد کنید" 
                            />
                            {
                                (AgenterrorPassword) ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger validate-error'>{ AgenterrorPassword }</small>
                                </span>
                            ):''}
                        </div>
                    </div> 
                    <div className="col-12 p-4 d-flex flex-reverse">
                        <div className='form-check form-switch form-check-reverse'>
                           
                            <input 
                                tabIndex='4'
                                name='flag'
                                type="checkbox"
                                checked={FlagStatus === true ? 'checked' : false}
                                className="form-check-input" 
                                role="switch" 
                                onChange={(e) => setFlag(e.target.checked)} 

                            /> 
                            {
                                (FlagStatus) ? (
                                    <label className="form-check-label px-2" forhtml="flexSwitchCheckDefault">
                                    <strong className='text-success'>فعال</strong>
                                    </label>
                                ) : (
                                    <label className="form-check-label px-2" forhtml="flexSwitchCheckDefault">
                                    <strong className='text-danger'>غیرفعال</strong>
                                </label>
                                )
                            }
                           
                            
                            {
                                (AgenterrorFlag) ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger validate-error'>{ AgenterrorFlag }</small>
                                </span>
                            ):''}                                        
                        </div>
                    </div>  
                    
                    
                </div>
            </div>
        </form>
        <div className="row p-0">
                        <div className='col-12 p-0'>
                        <Button
                            tab='2'
                            title='برگشت به صفحه نماینده ها'
                            design="rahpardaznet-button outline"
                            event={goToUserIndex}
                        />
                        <Button
                            tab='1'
                            title='ویرایش نماینده'
                            design="rahpardaznet-button"
                            event={userUdateHandler}
                        />
                        </div>
                    </div>
        </>
    )
}

export default EditAgent;